// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"yp-z","breadcrumbForward":"zp-z","breadcrumbBack":"Ap-z","selected":"Bp-z"};